module.exports = __webpack_public_path__ + "809cdec1c7ca4c73a464cc58bd96288e.eot";


//////////////////
// WEBPACK FOOTER
// ./~/demo-ui/asset/icon-font/fontello.eot
// module id = 697
// module chunks = 0